/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { AbstractObject, uuid } from '@src/app/model/abstract-object';

export class Core extends AbstractObject {
  name: string;
  areaId: uuid;
}
